import styled from 'styled-components';
import { Layout, Menu } from 'antd';
import variableStyles from '../../constants/variables-styles';
const { Sider } = Layout;

const StyledSider = styled(Sider)`
  background: ${variableStyles.primaryBasic};

  .logo {
    padding: 5px 20px;
    img {
      width: 150px;
      height: 70px;
    }
  }

  .logo-collapsed {
    padding: 3px 0px;
    img {
      width: 80px;
      height: 50px;
    }
  }

  .ant-layout-sider-children {
    top: 0;
    overflow-y: hidden;
    overflow-x: hidden;
    width: 100%;
    .logo-span {
      text-align: center;
      font-size: 30px;
      color: white;
      font-weight: 600;
      display: block;
    }
  }

  .ant-layout-sider-trigger {
    background: ${variableStyles.secondaryBlueBasic} !important;
  }

  .logout {
    position: fixed;
    bottom: 6%;
    color: ${variableStyles.backgroundBasic};
    width: ${(props) => (props.collapsed ? '80px' : '200px')};
    left: 0;
    cursor: pointer;
    padding: 10px;
    border-radius: 12px;
    font-size: ${variableStyles.fs14};
    padding-left: ${(props) => (props.collapsed ? '14px' : '10px')};
    &:hover {
      background: ${variableStyles.secondaryBlueLight};
    }
    span {
      margin-left: 20px;
    }
  }

  .username {
    position: fixed;
    bottom: 11%;
    color: ${variableStyles.backgroundBasic};
    width: ${(props) => (props.collapsed ? '80px' : '200px')};
    left: 0;
    padding: 10px;
    border-radius: 12px;
    font-size: ${variableStyles.fs14};
    padding-left: ${(props) => (props.collapsed ? '14px' : '0px')};
    text-align: center;
    span {
      font-size: large;
    }
  }
`;

const StyledMenu = styled(Menu)`
  .ant-menu-item-selected {
    background-color: ${variableStyles.secondaryBlueLight} !important;
  }
`;

export { StyledSider, StyledMenu };
